import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AgenticScreening from './AgenticScreening';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

export default function AgenticScreeningPage({
  searchId,
  conditions
}: {
  searchId: number;
  conditions: any[];
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <AgenticScreening searchId={searchId} conditions={conditions} />
    </QueryClientProvider>
  );
}
